import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import SavingAccount from './screens/deposite/saving-account';
import Home from './screens/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './screens/Layout';
import RecurringAccount from './screens/deposite/recurring-account';
import DailyDepoit from './screens/deposite/daily-deposit';
import MoneyBackAccount from './screens/deposite/money-back-account';
import FixedDeposit from './screens/deposite/fixed-deposit';
import MisDeposit from './screens/deposite/mis-deposit';
import PersonalLoad from './screens/loans/personal-loan';
import MonthlySecureLoan from './screens/loans/monthly-secure-loan';
import GroupLoan from './screens/loans/group-loan';
import DailyLoan from './screens/loans/daily-loan';
import PrivacyPolicy from './screens/privacy-policy';
import Gallery from './screens/gallery/image-gallery';


function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path='/deposit'>
            <Route path='saving-account' element={<SavingAccount />} />
            <Route path='recurring-account' element={<RecurringAccount />} />
            <Route path='daily-deposit' element={<DailyDepoit />} />
            <Route path='money-back-account' element={<MoneyBackAccount />} />
            <Route path='fixed-deposit' element={<FixedDeposit />} />
            <Route path='mis-deposit' element={<MisDeposit />} />
          </Route>
          <Route path='/loan'>
            <Route path='personal-loan' element={<PersonalLoad />} />
            <Route path='monthly-secure-loan' element={<MonthlySecureLoan />} />
            <Route path='group-loan' element={<GroupLoan />} />
            <Route path='daily-loan' element={<DailyLoan />} />
          </Route>
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/images' element={<Gallery />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
